import React from "react";
import { Link } from "react-router-dom";
import device from "../Assets/all-devices.svg";
import phone2 from "../Assets/phone-check.png";

function DownLoad() {
  return (
    <div>
      <div className="bg-green-400 text-center py-16 px-4 space-y-10">
        <div className="relative">
          <img
            src={phone2}
            alt="img"
            className="w-[50px] sm:w-[60px] lg:w-[100px] block m-auto"
          />
        
        </div>

        <div>
          <h1 className="text-2xl font-bold">Download Spotify</h1>
          <p className="text-center mt-6 text-sm font-medium">
            Play millions of songs and podcasts on your device
          </p>
        </div>

        <button className="mt-6 lg:mt-9 bg-white px-5 py-3 lg:py-3 rounded-3xl text-sm font-bold uppercase hover:transform translate duration-800 hover:scale-110">
          <Link to="/signup">Download</Link>
        </button>
      </div>

      <div className="bg-zinc-900 px-4 py-16 flex flex-col gap-8 md:py-20">
        <img
          src={device}
          alt="img"
          className="w-[18rem] block m-auto sm:w-[30rem]"
        />
        <h1 className="text-2xl font-bold text-center text-white">
          One account, listen everywhere.
        </h1>

        <div>
          <ul className=" text-center flex flex-col gap-4 uppercase font-medium text-sm text-white md:list-disc md:flex md:flex-row md:flex-wrap md:justify-between md:items-center md:gap-x-12 md:gap-y-4 md:text-base md:px-10 md:py-6 lg:flex lg:flex-row lg:flex-nowrap lg:gap-x-2 lg:px-16">
            <li>Mobile</li>
            <li>Computer</li>
            <li>Tablet</li>

            <li className=" underline text-green-500">
              <Link to="/">car</Link>
            </li>

            <li className=" underline text-green-500">
              <Link to="/">
                playstation<sup>®</sup>
              </Link>
            </li>

            <li className=" underline text-green-500">
              <Link to="/">xbox</Link>
            </li>

            <li className=" underline text-green-500">
              <Link to="/">tv</Link>
            </li>

            <li className=" underline text-green-500">
              <Link to="/">speaker</Link>
            </li>

            <li className=" underline text-green-500">
              <Link to="/">web player</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default DownLoad;
